import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import {
  queryProjects,
  queryIsFeaturedListing,
  DISCOVERY_HOMEPAGE_ASSET_NAME,
} from '../LandingPage/LandingPage.duck';

export const loadData = (params, search, config) => dispatch => {
  const pageId = params.pageId;
  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;

  const loaders = [dispatch(fetchPageAssets(pageAsset, hasFallbackContent))];

  // The discovery-homepage asset reuses landing-page sections (e.g. listing-slider,
  // new-listing) that need real project/featured-listing data, same as route "/".
  if (pageId === DISCOVERY_HOMEPAGE_ASSET_NAME) {
    loaders.push(dispatch(queryProjects(config)));
    loaders.push(dispatch(queryIsFeaturedListing(config)));
  }

  return Promise.all(loaders);
};
